import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { Plus } from 'lucide-react';
import { useLibraries, useLibraryBoards } from '@/lib/api/queries';
import { useSessionStore } from '@/stores/session';
import { EmptyState, Skeleton } from '@/components/Misc';
import { Button } from '@/components/Button';
import { usePermission } from '@/features/workspace/usePermission';
import { BoardCard } from './BoardCard';
import { CreateBoardDialog } from './BoardDialogs';
import { uploadManager } from '@/features/upload/UploadManager';

export function LibraryPage() {
  const { ws = '', libraryId = '' } = useParams();
  const wsId = useSessionStore((s) => s.workspace?.id);
  const libs = useLibraries(wsId);
  const lib = libs.data?.find((l) => l.id === libraryId);
  const boards = useLibraryBoards(libraryId);
  const canManage = usePermission('MANAGE_BOARD');
  const [create, setCreate] = useState(false);
  return (
    <div className="p-4 md:p-6">
      <div className="mb-4 flex items-center gap-3">
        <div>
          <h1 className="text-lg font-semibold">{lib?.name ?? 'Library'}</h1>
          {lib?.description && <p className="text-sm text-fg-muted">{lib.description}</p>}
        </div>
        {canManage && (
          <Button className="ml-auto" size="sm" onClick={() => setCreate(true)}>
            <Plus size={14} /> New board
          </Button>
        )}
      </div>
      {boards.isPending && (
        <div className="flex flex-wrap gap-3">
          {Array.from({ length: 6 }, (_, i) => (
            <Skeleton key={i} className="h-[168px] w-44 rounded-lg" />
          ))}
        </div>
      )}
      {boards.data && boards.data.length === 0 && <EmptyState title="No boards yet" body="Create a board to start organising assets." action={canManage ? <Button variant="primary" onClick={() => setCreate(true)}>New board</Button> : undefined} />}
      <div className="flex flex-wrap gap-3">
        {boards.data?.map((b) => (
          <BoardCard key={b.id} board={b} to={`/w/${ws}/b/${b.id}`} onDropFiles={(target, dt) => void uploadManager.enqueueDataTransfer(dt, target.id)} />
        ))}
      </div>
      {create && <CreateBoardDialog parent={null} libraryId={libraryId} onClose={() => setCreate(false)} />}
    </div>
  );
}
